import React from 'react'
import propTypes from 'prop-types'
import BaseModal from '@material-ui/core/Modal'
import get from 'lodash/get'
import classNames from 'classnames'

import { ErrorModalContent } from './GenericErrorModal'

import './modal.scss'

export const Modal = ({ children, small, hideCloseButton, error, ...props }) => {
  const { className, ...passThroughProps } = props
  const classes = classNames('modal-container', props.className)

  return (
    <BaseModal {...passThroughProps} className={classes}>
      <section className={`modal modal--centered ${small ? 'modal--small' : ''}`}>
        <CloseButton hideCloseButton={hideCloseButton} {...props} />
        {error && <ErrorModalContent onClose={get(props, 'onClose', null)} />}
        {!error && children}
      </section>
    </BaseModal>
  )
}

export const ModalHeader = ({ children, className }) => {
  const classes = classNames('modal__header', className)

  return (
    <div className={classes}>
      <h1>
        {children}
      </h1>
    </div>
  )
}

export const ModalSubHeader = ({ children, className }) => {
  const classes = classNames('modal__sub-header', className)

  return (
    <div className={classes}>
      <h3>
        {children}
      </h3>
    </div>
  )
}

export const ModalContent = ({ children, className }) => {
  const classes = classNames('modal__main', className)

  return (
    <div className={classes}>
      {children}
    </div>
  )
}

export const ModalFooter = ({ children, className }) => {
  const classes = classNames('modal__footer', className)

  return (
    <footer className={classes}>
      {children}
    </footer>
  )
}

export const CloseButton = (props) => !props.hideCloseButton &&
  <button onClick={() => props.onClose()} className='close-button'>
    <span>x</span>
  </button>

Modal.propTypes = {
  open: propTypes.bool.isRequired,
  hideCloseButton: propTypes.bool,
  small: propTypes.bool,
  onClose: propTypes.func,
  className: propTypes.string
}
